<template>
    <div id="organisation-switcher-wrap">
        <FullPageLoader :isLoading="loading"/>

        <slide-up-down :active="showOrganisations">
            <div id="organisation-switcher-dropdown">
                <div class="organisation" v-for="organisation in organisations" :key="'org_'+organisation.id" @click="selectOrganisation(organisation.organisation)">
                    <div class="logo" v-if="organisation.logo">
                        <img :src="organisation.logo" :alt="`Logo ${organisation.name}`"/>
                    </div>
                    <div class="organisation-name" v-if="!organisation.logo || showOrganisations">{{ organisation.name }}</div>
                </div>
            </div>
        </slide-up-down>

        <div id="organisation-switcher" @click="showOrganisations = !showOrganisations" :class="{ 'active': showOrganisations }" v-if="organisations.length > 1">
            <b-icon icon="chevron-down" class="arrow"/>
        </div>

        <div class="modal-background" v-show="showOrganisations" @click="showOrganisations = false"></div>
    </div>
</template>

<script>
export default {
    name: 'OrganisationSwitcher',

    data () {
        return {
            showOrganisations: false,
            loading: false
        }
    },

    computed: {
        organisations () {
            const organisations = Object.values(this.$store.state.user.organisations)

            return [
                organisations.find((x) => {
                    return x.organisation === this.$store.state.user.organisation
                }),
                ...organisations.filter(org => org.organisation !== this.$store.state.user.organisation)
            ]
        }
    },

    methods: {
        selectOrganisation (organisationId) {
            // Selecting the same organisation
            if (this.$store.state.user.organisation === organisationId) {
                this.showOrganisations = false
                return
            }

            this.loading = true
            this.showOrganisations = false

            this.$store.dispatch('switchOrganisation', organisationId).then(() => {
                this.loading = false

                this.$store.dispatch('setAuthRedirected', false)
                this.$router.push({ name: 'Dashboard', query: { org: organisationId } })
            })
        }
    }
}
</script>
